import { type DataFunctionArgs, json, redirect } from '@remix-run/node'
import { Link, useLoaderData } from '@remix-run/react'
import { SpecialServicesEnum, StatusEnum } from 'types/enums.ts'
import { Card } from '~/components/ui/card.tsx'
import { Spacer } from '~/components/ui/spacer.tsx'
import { prisma } from '~/utils/config/db.server.ts'

export async function loader({ request, params }: DataFunctionArgs) {
  const service = await prisma.service.findUnique({
    where: {
      specialService: SpecialServicesEnum.NATALCHART,
      status: StatusEnum.ACTIVE,
    },
  })

  if (!service) return redirect('/')

  return json({
    service,
  })
}

export default function NatalChart() {
  const { service } = useLoaderData<typeof loader>()
  return (
    <div className="mx-auto max-w-[1100px]">
      <Spacer size="4xs" />
      <Card className="px-4 py-8">
        <h2 className="text-center text-h5 text-secondary">
          Pide tu Carta Natal escrita y recíbela en 7 días
        </h2>
        <Spacer size="5xs" />
        <p className="text-center">
          ¿Qué diseño te gustaría elegir para tu Carta?
        </p>
        <div className="flex items-center justify-center space-x-3 md:space-x-6">
          <Link to={`/check/special/${service.id}?specialServiceInput=reyes`}>
            <img
              src="/images/natal-chart/reyes.png"
              alt="natal-cart-img"
              className="h-full max-h-[550px] w-full max-w-[350px] object-cover"
            />
          </Link>
          <Link to={`/check/special/${service.id}?specialServiceInput=jana`}>
            <img
              src="/images/natal-chart/jana.png"
              alt="natal-cart-img"
              className="h-full max-h-[550px] w-full max-w-[350px] object-cover"
            />
          </Link>
        </div>
      </Card>
    </div>
  )
}
